import { attr, ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';
import CatalogObjectReference from '@square/dashboard-items-data/models/invoices/cart/catalog-object-reference';
export default ProtoBaseModel.extend({
  id: attr(String),
  name: attr(String),
  ordinal: attr(Number),
  catalogObjectReference: attr(CatalogObjectReference)
}).reopenClass({
  createFor(menuCategory) {
    if (menuCategory) {
      return this.create({
        id: menuCategory.get('id'),
        name: menuCategory.get('name'),
        ordinal: menuCategory.get('ordinal'),
        catalogObjectReference: CatalogObjectReference.fromCatalogModel(menuCategory)
      });
    }
    return undefined;
  }
});